import { User } from '@/core/models/user.model';
import { WidgetTeacherHomework } from './widget-teacher-homework.model';

export class WidgetTeacherPerson extends User {

  courseId: number;
  classId: number;
  homeworkStatus: string;
  homeworks: {
    content: WidgetTeacherHomework[];
    more: boolean;
    page: number;
  };

  constructor(data: any) {
    super(data);
    this.classId = data.classId;
    this.courseId = data.courseId;
    this.homeworkStatus = data.homeworkStatus;
    this.homeworks = {
      page: 0,
      more: true,
      content: []
    };
  } 

}